import React, {ReactNode} from 'react';
import {UncontrolledTooltip} from 'reactstrap';

interface TooltipProps {
    // The id of the element the tooltip belongs to.
    target: string;
    children: ReactNode;
    // A keyboard shortcut, shown in grey after the name.
    shortcut?: string;
    placement?: 'top' | 'bottom' | 'left' | 'right';
}

/*
 * A name and a shortcut, after a 500ms delay, on hover and on keyboard
 * focus. A tooltip never holds information you need to finish a task.
 */
const Tooltip: React.FC<TooltipProps> = ({
    target,
    children,
    shortcut,
    placement = 'top'
}) => (
    <UncontrolledTooltip
        target={target}
        placement={placement}
        delay={{show: 500, hide: 0}}
        className="mx-tooltip"
        fade={false}
    >
        {children}
        {shortcut && <kbd className="mx-tooltip-shortcut">{shortcut}</kbd>}
    </UncontrolledTooltip>
);

export default Tooltip;
